import axios from 'axios';
import convertObjectToEncodedUrl from '../utils/convertObjectToEncodedUrl';

const selectors = {
    emailInput: '[data-back-in-stock-email]',
    errorMessage: '[data-back-in-stock-error]',
    productInput: '[data-back-in-stock-product]',
    submitButton: '[data-back-in-stock-submit]',
    successMessage: '[data-back-in-stock-success]',
    variantInput: '[data-back-in-stock-variant]',
};

const classes = {
    errorMessageActive: 'form__error-message--active',
};

class BackInStockForm {
    /**
     * @param {Element} element
     */
    constructor(element) {
        this.element = element;
        this.emailInput = this.element.querySelector(selectors.emailInput);
        this.errorMessageContainer = this.element.querySelector(
            selectors.errorMessage
        );
        this.productInput = this.element.querySelector(selectors.productInput);
        this.submitButton = this.element.querySelector(selectors.submitButton);
        this.successMessageContainer = this.element.querySelector(
            selectors.successMessage
        );
        this.variantInput = this.element.querySelector(selectors.variantInput);

        this.registerEventListeners();
    }

    set errorMessage(message) {
        this.errorMessageContainer.innerHTML = message;
        this.errorMessageContainer.classList.add(classes.errorMessageActive);
    }

    set successMessage(message) {
        this.successMessageContainer.innerHTML = message;
    }

    set variant(variant) {
        this.variantInput.value = variant.id;
    }

    registerEventListeners() {
        this.element.addEventListener('submit', event => this.onSubmit(event));
    }

    /**
     * @param {event} event
     */
    onSubmit(event) {
        event.preventDefault();

        if (!this.emailInput.value || this.emailInput.value.length === 0) {
            this.errorMessage = 'Please enter an email address';
            return;
        }

        if (this.variantInput.value && this.productInput.value) {
            this.submitButton.disabled = true;
            this.errorMessage = '';
            this.successMessage = '';

            axios({
                url: `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.element.dataset.klaviyoKey}`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'revision': '2024-07-15',
                    'Authorization': `Klaviyo-API-Key ${import.meta.env.VITE_KLAVIYO_BIS_API_KEY}`,
                },
                data: {
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            channels: ['EMAIL'],
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: this.emailInput.value,
                                    },
                                },
                            },
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: `$shopify:::$default:::${this.variantInput.value}`,
                                },
                            },
                        },
                    },
                },
            })
                .then(() => {
                    this.successMessage =
                        window.translations.product.backInStock.success;
                    this.element
                        .querySelectorAll(`:not(${selectors.successMessage})`)
                        .forEach(element => element.classList.add('u-hide'));
                })
                .catch(error => {
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        console.error('Error response data:', error.response.data);
                        console.error('Error response status:', error.response.status);
                        console.error('Error response headers:', error.response.headers);
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.error('Error request:', error.request);
                    } else {
                        // Something happened in setting up the request that triggered an error
                        console.error('Error message:', error.message);
                    }
                    this.errorMessage = window.translations.product.backInStock.error;
                });
        }
    }
}

export default BackInStockForm;
